import React from 'react';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import PublicPageShell from '../components/PublicPageShell';
import PageMeta from '../components/PageMeta';
import { blogPosts, formatBlogDate } from '../content/blogPosts';

function BlogPage() {
  return (
    <PublicPageShell>
      <PageMeta
        title="Zaphar Journal | Budgeting & Money Habits"
        description="Practical Zaphar guides for receipt tracking, budgeting, recurring expenses, and calmer monthly money reviews."
      />
      <section className="py-14 sm:py-20">
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-amber-300/85">Zaphar journal</p>
        <h1 className="mt-4 max-w-3xl text-4xl font-semibold tracking-tight text-stone-50 sm:text-6xl">
          Practical ideas for clearer spending.
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-stone-300 sm:text-lg">
          Simple guides for getting more value from receipts, budgets, and everyday money habits.
        </p>
      </section>

      <section aria-labelledby="all-posts-heading" className="border-t border-white/8 py-10">
        <h2 id="all-posts-heading" className="text-2xl font-semibold text-stone-50">All posts</h2>
        <div className="mt-7 grid gap-5 md:grid-cols-2">
          {blogPosts.map((post) => (
            <article key={post.slug} className="group flex flex-col rounded-[28px] border border-white/10 bg-white/[0.045] p-6 transition hover:-translate-y-1 hover:border-amber-300/25 hover:bg-white/[0.065]">
              <div className="flex flex-wrap items-center gap-2 text-xs text-stone-400">
                <span className="rounded-full bg-amber-300/10 px-3 py-1 font-medium text-amber-200">{post.category}</span>
                <time dateTime={post.publishedAt}>{formatBlogDate(post.publishedAt)}</time>
                <span aria-hidden="true">·</span>
                <span>{post.readTime}</span>
              </div>
              <h2 className="mt-5 text-2xl font-semibold tracking-tight text-stone-50">{post.title}</h2>
              <p className="mt-3 flex-1 text-sm leading-6 text-stone-400">{post.excerpt}</p>
              <Link to={`/blog/${post.slug}`} className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-amber-200">
                Read article
                <ArrowRightIcon className="h-4 w-4 transition group-hover:translate-x-1" aria-hidden="true" />
              </Link>
            </article>
          ))}
        </div>
      </section>
    </PublicPageShell>
  );
}

export default BlogPage;
